import cmfApi from "../index";

const API_URL = "/votes/rank/";

function getRank(token, id) {
	const config = {
		headers: {
			Accept: "application/json",
			Authorization: `Bearer ${token}`,
		},
	};


	const URL = id
		? `${API_URL}?receiver_id=${id}`
		: API_URL;

	return new Promise(function (resolve, reject) {
		cmfApi.get(URL, config).then(
			(response) => {
				var result = response.data;
				resolve(result);
			},
			(error) => {
				reject(error);
			}
		);
	});
}

export { getRank };
